import { reactive, watch } from 'vue'
import { useStore } from 'vuex'
import { isdeepsame } from '@/plugins/utils'
import { ElMessage } from 'element-plus'

export default (origin: any, update: () => void): any => {
  const store = useStore()
  const copy = JSON.parse(JSON.stringify(origin))
  const model = reactive(copy)
  watch(
    model,
    () => {
      store.commit('status/editing', !isdeepsame(copy, origin))
    },
    { deep: true }
  )
  const beforeUpdate = () => {
    // if (store.getters.editing) {
    //   update()
    // } else {
    //   ElMessage.warning('请在修改后保存')
    // }
    update()
  }
  const clear = () => {
    Object.entries(copy).forEach(([k, v]) => {
      origin[k] = JSON.parse(JSON.stringify(v))
    })
    store.commit('status/editing', false)
  }
  const reset = () =>
    Object.entries(origin).forEach(([k, v]) => {
      model[k] = JSON.parse(JSON.stringify(v))
    })
  return [model, beforeUpdate, clear, reset]
}
